import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

import { IconboxOneComponent } from './iconbox-one.component'; 

@NgModule({
  declarations: [IconboxOneComponent],
  exports: [IconboxOneComponent],
  imports: [
    CommonModule, 
  ]
})
export class IconboxOneModule {}
